import { css } from 'emotion';

export const zoomControl = css`
  display: flex;
  flex-direction: column;
  pointer-events: all;
  width: 30px;
  margin-left: 8px;

  & > :not(:first-child) {
    border-top: 0;
  }

  && {
    // Overwrites leaflet leaflet-control styles
    margin-left: 0;
  }
`;
